











import { Vue, Component,Prop} from "vue-property-decorator";
import { Getter, Action } from "vuex-class";
import getUrlParam from '@/common/utils/getUrlParam';
import fetch from "@/common/api/fetch";
import { AxiosPromiseData, AxiosPromiseError } from "@/common/interface";
@Component
export default class gachaMainImg extends Vue {
  @Getter("gachaTypeParameter") gachaTypeParameter!: object;
  @Getter("gachaStart") gachaStart!: boolean;
  @Getter("uid") uid!: string;
  @Getter("urlUid") urlUid!: string;
  @Getter('openId') openId!: string;
  @Action("changeUid") changeUid!: Function;
  @Action("changeUrlUid") changeUrlUid!: Function;
  @Action("changeSelectBGM") changeSelectBGM!: Function;
  @Action("changeGachaStart") changeGachaStart!: Function;
  @Action("changePosterName") changePosterName!: Function;
  @Getter("posterName") posterName!: string;
  @Getter("startTime") startTime: any;
  @Getter("deadline") deadline!: number;
  @Getter("orgId") orgId!: string;
  getUrlParam: Function = getUrlParam;
  gainActivity(joinType:any){
      const activityDeadline: number = this.deadline;
      const activityStartTime: number = this.startTime;
      const nowTimestamp: number = new Date().valueOf();
      if(activityStartTime > nowTimestamp){
        Vue.$toast.error('活动还未开始噢~');
      }else{
        if(nowTimestamp<activityDeadline){
          if(joinType=="self"){
            if(this.uid){
                let formdata = {
                  "activityId":getUrlParam('broadcastId'),
                  "leaderId":this.uid,
                  "openId":this.openId
                }
                this.startGahca(formdata)
              }else{
                Vue.$modal({
                  ok: (
                    name: string,
                    phone: string,
                    authCode: string,
                    additionalInfo: string,
                    instId?: string,
                  ) => {
                    this.joinActivity(name, phone, authCode, additionalInfo, instId);
                  }
              });
            }
          }else{
            let formdata = {
              "activityId":getUrlParam('broadcastId'),
              "leaderId":this.urlUid,
              "openId":this.openId
            }   
            this.startGahca(formdata)
          }
        }else{
          Vue.$toast.error('该活动已过期');
        }
      }
    }
    startGahca(param:any){
      var that = this;
      fetch
      .newpost("anon/gacha/gainActivity", param)
      .then((res: AxiosPromiseData) => {
        if(res.result.code == "SCHOLARSHIP_DAILY_MAX_TIME" ||res.result.code == "SCHOLARSHIP_ALREADY_MAX" || res.result.code == "SCHOLARSHIP_MAX_TIME" || res.result.code == "SCHOLARSHIP_ALREADY_HELP" || res.result.code == "PRIZE_DAILY_MAX_TIME" ||  res.result.code == "PRIZE_MAX_TIME"||  res.result.code == "PRIZE_ALREADY_GAIN" || res.result.code == "PRIZE_NO_LEFT" || res.result.code == "PRIZE_ALREADY_HELP_GAIN" || res.result.code == "PRIZE_ALREADY_HELP_NO_GAIN" ){
          that.$emit("showGachaToastModal",res.result);
        }else{
          const payload = {
              selectedBGM:{
                url:'https://image.xiaomaiketang.com/xm/ddNFAbMG7d.mp3',
                loop:false
              }
          };
          that.changeSelectBGM(payload);
          that.changeGachaStart(true);
          setTimeout(function(){
            const payload = {
              selectedBGM:{
                url:'https://image.xiaomaiketang.com/xm/nMe6DhZz5k.mp3',
                loop:false
              }
            };
            that.changeSelectBGM(payload);
            that.$emit("showGachaToastModal",res.result);
          },5000)
        }
      }).catch((error: AxiosPromiseError) => {
        Vue.$toast.error(error.resultMsg || error.message);
      });
    }
    joinActivity(
      name: string,
      phone: string,
      authCode: string,
      additionalInfo: string,
      instId?: string,
    ) {
      if (this.orgId && !instId) {
        Vue.$toast.error('请选择校区');
        return null;
      }
      const data = {
        name,
        instId,
        phone,
        authCode,
        additionalInfo,
        openId: this.openId,
        activityId: getUrlParam("broadcastId")
      };
      const promoterId: string = getUrlParam("promoterId") as string;
      const referralId: string = getUrlParam("referralId") as string;
      if (promoterId) {
        (data as any).promoterId = promoterId;
      }
      if (referralId) {
        (data as any).referralId = referralId;
      }
      var that = this;
      fetch
        .newpost("anon/gacha/joinActivity", data)
        .then((res: AxiosPromiseData) => {
          this.changeUid({ uid: res.result.id });
          this.changePosterName(res.result.name);
           Vue.$toast.success("报名成功");
          if(that.urlUid){
            this.changeUrlUid(res.result.id);
            this.backHome();
          }else{
            this.changeUrlUid(res.result.id);
            let formdata = {
              "activityId":getUrlParam('broadcastId'),
              "leaderId":this.uid,
              "openId":this.openId
            }
            this.startGahca(formdata);
          }
          // this.getRankList();
          // this.changeJoinInfo({ name, phone, signupItemConfig: additionalInfo });
          // this.changeJoinNumber(this.joinNumber + 1);
          // this.changeLeftQuota(this.leftQuota - 1);
        }).catch((error: AxiosPromiseError) => {
          Vue.$toast.error(error.resultMsg || error.message);
        });
    }

  backHome(){
    const url = window.location.href.replace(/&uid=\d*/, "");
    window.location.href= url;
    location.reload();
  }
}
